import { TitleCasePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Injectable,
  Output,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbDatepickerConfig,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { AdministratorFacade, Helper } from '@piqet-angular/data';
import {
  CustomModalService,
  FileUploadComponent,
  LicenseDuration,
  SignupSourceType,
  SignupSourceTypeArray,
  UpdatedByEnum,
} from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { AdminOrganizatioDataGridService } from 'libs/features/src/lib/layout/administrator/user-managment/admin-organization/admin-organization-data-grid.service';
import { ToastrService } from 'ngx-toastr';
import { allItemsPayload } from '@piqet-angular/shared';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'piqet-angular-new-admin-organization',
  templateUrl: './new-admin-organization.component.html',
  styleUrls: ['./new-admin-organization.component.scss'],
  providers: [TitleCasePipe],
})
export class NewAdminOrganizationComponent {
  adminOrganizationListData: any;
  setStartDateForPayload: any;
  setExpiryDateForPayload: any;
  adminOrganizationForm!: FormGroup;
  modalLabel: any;
  imageChangedEvent: any = '';
  adminOrganizationData: any;
  countryList: any;
  submitted = false;
  selectedFiles: any;
  fileToUpload: any;
  imagePreview = '';
  getImage: any;
  isImageValid = true;
  stream: any;
  fileBase64: any;
  imageUrl: any = null;
  private currentBlobUrl: string | null = null;
  organizationId: any;
  selectedCountry: any;
  isShowImage = false;
  minDate: any;
  isShowChange = false;
  isDisabled: any;
  expDate: any;
  isCheckMinDate: any;
  isShowDateInvalid: any;
  editTimeSetMinDate: any;
  licenseTypeList: any;
  licenseUpdatedFlag = false;
  @Output() saveNewAdminOrganizationEvent = new EventEmitter<any>();
  iserror: boolean = false;
  responseTest: any;
  @ViewChild('myFileInput', { static: false }) myFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fileUploadComponent', { static: false }) fileUploadComponent!: FileUploadComponent;
  organizarionBsConfig = {
    containerClass: 'organizationDatePicker',
    showWeekNumbers: false,
    dateInputFormat: 'DD/MM/YYYY',
  };
  organizarionBsConfigExp = {
    containerClass: 'organizationDatePicker',
    showWeekNumbers: false,
    dateInputFormat: 'DD/MM/YYYY',
  };
  formattedStartDate: any;
  formattedExpDate: any;
  startDateInput: any;
  expiryDateInput: any;
  isLogoConsented: boolean = false;
  signUpSourceList: any;
  sourceType!: number | null;
  showCommentBox: boolean = false;
  labelText: string = 'Comment';
  licenseUpdatedBy!: number;
  licenseLevelList: any;
  licenseLevelId!: number;
  licenseMessage: string = '';
  rangeList: any;
  userCount: number = 0;
  selectedLicenseId: number = 10;
  selectedName: string = '';
  matchingName: string = '';
  durationList: any;
  licenseTypeValue: number = 0;
  isLicenseDurationDisabled: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    public admnistratorFacade: AdministratorFacade,
    private modal: CustomModalService,
    private cd: ChangeDetectorRef,
    private config: NgbDatepickerConfig,
    private calendar: NgbCalendar,
    private titleCasePipe: TitleCasePipe,
    private administratorService: AdministratorService,
    private adminOrganizatioDataGridService: AdminOrganizatioDataGridService,
    private toaster: ToastrService,
    private helper: Helper,
    private localeService: BsLocaleService,
    private swalService: SwalService,
    private sanitizer: DomSanitizer
  ) {
    enGbLocale.weekdaysShort = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    enGbLocale.months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    enGbLocale.week.dow = 1;
    defineLocale('en-gb', enGbLocale);
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.adminOrganizationData =
      this.modal?.modalService?.config?.initialState?.['newAdminOrganizationData'];
    this.isShowImage =
      this.modalLabel == 'Review organization detail' && this.adminOrganizationData.pictureContent
        ? true
        : false;
    if (this.modalLabel == 'Review organization detail') {
      // Format the date in the desired way (YYYY/MM/DD)
      const [day, month, year] = this.adminOrganizationData.startDate.split('/');
      this.formattedStartDate = `${year}-${month}-${day}`;
      const [dayExp, monthExp, yearExp] = this.adminOrganizationData.expDate.split('/');
      this.formattedExpDate = `${yearExp}-${monthExp}-${dayExp}`;
      this.editTimeSetMinDate = this.parseDate(this.adminOrganizationData.startDate);
      this.minDate = this.editTimeSetMinDate;
    }
    this.durationList = Object.entries(LicenseDuration).map(([key, value]) => ({
      id: key,
      name: value,
    }));
  }

  parseDate(dateString: string): Date {
    const [day, month, year] = dateString.split('/');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }

  ngOnInit() {
    this.localeService.use('en-gb');
    this.signUpSourceList = SignupSourceTypeArray;
    this.licenseUpdatedBy = this.adminOrganizationData?.licenseUpdatedBy;
    this.licenseLevelList = this.adminOrganizationData?.licenseLevelList;
    this.licenseLevelId = this.adminOrganizationData?.licenseLevel;
    this.licenseTypeList = this.adminOrganizationData?.licenseTypeList;
    this.rangeList = this.adminOrganizationData?.rangeList;
    this.startDateInput = !!this.adminOrganizationData?.startDate
      ? this.adminOrganizationData?.startDate
      : new Date();
    this.expiryDateInput = !!this.adminOrganizationData?.expDate
      ? this.adminOrganizationData?.expDate
      : new Date();
    this.showCommentBox =
      this.adminOrganizationData?.signupSource === SignupSourceType.Other ||
      this.adminOrganizationData?.signupSource === SignupSourceType.ConferenceTradeEvent;
    this.labelText =
      this.adminOrganizationData?.signupSource == SignupSourceType.Other
        ? 'Comment'
        : 'Please specify the event';
    this.sourceType = this.adminOrganizationData?.signupSource;
    this.selectedLicenseId = this.licenseLevelId;
    this.adminOrganizationForm = this.formBuilder.group({
      organizationName: ['', Validators.required],
      startDate: [null, Validators.required],
      expiryDate: [null, Validators.required],
      noOfLicence: ['', Validators.required],
      licenseLevel: [null, Validators.required],
      licenseType: [null, Validators.required],
      baseUrl: [null],
      country: [null, Validators.required],
      address: [null],
      sessionTimeOut: [null, [Validators.required, Validators.min(10)]],
      source: [null, Validators.required],
      sourceComment: [''],
      licenseDuration: [null],
    });
    this.getModalDataAsync();
    this.selectDuration();
  }

  async getModalDataAsync() {
    await this.getListingData();
  }
  selectDuration() {
    const rawStart = this.adminOrganizationData?.startDate;
    const rawExpiry = this.adminOrganizationData?.expDate;

    if (!rawStart || !rawExpiry) {
      return;
    }

    const parseDate = (dateStr: string): Date => {
      const [day, month, year] = dateStr.split('/').map(Number);
      return new Date(year, month - 1, day);
    };

    const startDate = rawStart instanceof Date ? rawStart : parseDate(rawStart);
    const expiryDate = rawExpiry instanceof Date ? rawExpiry : parseDate(rawExpiry);

    startDate.setHours(0, 0, 0, 0);
    expiryDate.setHours(0, 0, 0, 0);

    this.startDateInput = startDate;
    this.expiryDateInput = expiryDate;

    const timeDiff = expiryDate.getTime() - startDate.getTime();
    const durationDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    const licenseTypeName = this.licenseTypeList?.find(
      (x: any) => x.id === this.adminOrganizationData?.licenseType
    )?.name;

    if (licenseTypeName === 'Trial' && durationDays <= 15) {
      this.isLicenseDurationDisabled = true;
      const trialExists = this.durationList.some((d: any) => d.id === 'Trial15');
      if (!trialExists) {
        this.durationList.unshift({ id: 'Trial15', name: '15 Days' });
        this.durationList = [...this.durationList];
      }

      setTimeout(() => {
        this.adminOrganizationForm.get('licenseDuration')?.setValue('Trial15');
      });
    } else if (licenseTypeName === 'Purchased') {
      this.isLicenseDurationDisabled = false;

      if (durationDays >= 180 && durationDays <= 185) {
        const sixMonthOption = this.durationList.find(
          (d: any) => d.name === '6 Months' || d.id === 'SixMonths'
        );
        if (sixMonthOption) {
          setTimeout(() => {
            this.adminOrganizationForm.get('licenseDuration')?.setValue(sixMonthOption.id);
          });
        }
      } else if (durationDays >= 365 && durationDays <= 366) {
        const oneYearOption = this.durationList.find(
          (d: any) => d.name === '1 Year' || d.id === 'OneYear'
        );
        if (oneYearOption) {
          setTimeout(() => {
            this.adminOrganizationForm.get('licenseDuration')?.setValue(oneYearOption.id);
          });
        }
      } else {
        const customOption = this.durationList.find(
          (d: any) => d.name === 'Custom' || d.id === 'Custom'
        );
        if (customOption) {
          setTimeout(() => {
            this.adminOrganizationForm.get('licenseDuration')?.setValue(customOption.id);
          });
        }
      }
    } else {
      const customOption = this.durationList.find(
        (d: any) => d.name === 'Custom' || d.id === 'Custom'
      );
      if (customOption) {
        setTimeout(() => {
          this.adminOrganizationForm.get('licenseDuration')?.setValue(customOption.id);
        });
      }
    }
  }

  async getListingData() {
    this.countryList = this.adminOrganizationData?.countryItems;
    this.organizationId = this.adminOrganizationData?.organizationId;
    this.getImage = this.adminOrganizationData?.pictureContent;
    const urlParts = this.getImage?.split('/');
    // Get the last part of the URL, which should be the filename
    if (urlParts) {
      const fileName = urlParts[urlParts?.length - 1];
      this.selectedFiles = fileName ? fileName : null;
      this.isShowChange = this.selectedFiles ? true : false;
      this.isImageValid = true;
    }
    this.mapCountryList();
    this.setFormValue();
  }

  async mapCountryList() {
    await this.countryList?.map((item: any) => {
      if (item.id == this.adminOrganizationData?.countryId) {
        return (this.selectedCountry = item);
      }
    });
  }

  setFormValue() {
    this.adminOrganizationForm.patchValue({
      country: this.selectedCountry,
      organizationName: this.adminOrganizationData.name,
      noOfLicence: this.adminOrganizationData.totalUsers,
      baseUrl: this.adminOrganizationData.baseImgUrl,
      sessionTimeOut: this.adminOrganizationData.sessionManagement,
      address: this.adminOrganizationData?.address,
      source: this.signUpSourceList.find(
        (x: any) => x.id === this.adminOrganizationData?.signupSource
      ),
      sourceComment: this.adminOrganizationData?.signupSourceComment,
      licenseType: this.adminOrganizationData?.licenseType,
      licenseLevel: this.adminOrganizationData?.licenseLevel,
    });
    this.userCount = this.adminOrganizationData.totalUsers;
    this.isLogoConsented = this.adminOrganizationData.logoConsent;
  }

  dateChange(dataStart: any) {
    if (typeof dataStart != 'object') {
      dataStart = '';
      const [day, month, year] = dataStart?.split('/').map(Number);
      const data = {
        day: day,
        month: month, // Months are zero-based, so add 1
        year: year,
      };
      this.isCheckMinDate = new Date(data.year, data.month - 1, data.day); // Note: Months are zero-based in JavaScript dates
    } else {
      const dateObj = new Date(dataStart);
      const data = {
        day: dateObj.getDate(),
        month: dateObj.getMonth() + 1, // Months are zero-based, so add 1
        year: dateObj.getFullYear(),
      };
      this.isCheckMinDate = new Date(data.year, data.month - 1, data.day); // Note: Months are zero-based in JavaScript dates
    }

    if (this.isCheckMinDate > this.expDate) {
      this.minDate = dataStart;
      this.isShowDateInvalid = true;
    } else {
      this.isShowDateInvalid = false;
    }
    this.minDate =
      !!this.editTimeSetMinDate && typeof dataStart != 'object'
        ? this.editTimeSetMinDate
        : dataStart;
  }

  dateChangeForExp(dateExp: any) {
    if (typeof dateExp != 'object') {
      dateExp = '';
      const [day, month, year] = dateExp?.split('/').map(Number);
      const data = {
        day: day,
        month: month, // Months are zero-based, so add 1
        year: year,
      };
      this.expDate = new Date(data.year, data.month - 1, data.day); // Note: Months are zero-based in JavaScript dates
    } else {
      const dateObj = new Date(dateExp);
      const data = {
        day: dateObj.getDate(),
        month: dateObj.getMonth() + 1, // Months are zero-based, so add 1
        year: dateObj.getFullYear(),
      };
      this.expDate = new Date(data.year, data.month - 1, data.day); // Note: Months are zero-based in JavaScript dates
    }
    if (this.isCheckMinDate <= this.expDate) {
      this.isShowDateInvalid = false;
    } else {
      this.isShowDateInvalid = true;
    }
    if (isNaN(this.isCheckMinDate.getTime())) {
      this.isShowDateInvalid = false;
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().startsWith(term.toLowerCase());
  }
  onClose() {
    this.modal.close();
  }

  removeImage() {
    this.isShowChange = false;
    this.iserror = false;
    this.selectedFiles = null;

    // Reset the file upload component using ViewChild
    if (this.fileUploadComponent) {
      this.fileUploadComponent.reset();
    }

    if (this.myFileInput?.nativeElement) {
      this.myFileInput.nativeElement.value = '';
    }
    this.fileBase64 = null;
    this.getImage = null;
    this.isShowImage = false;
    this.isImageValid = true;

    // Clean up object URL if it exists
    if (this.currentBlobUrl) {
      URL.revokeObjectURL(this.currentBlobUrl);
      this.currentBlobUrl = null;
    }
    this.imageUrl = null;

    this.toaster.success('Image has been deleted');
  }

  deleteConfirmation() {
    this.swalService
      .confirm(
        'Are you sure?',
        'Do you really want to delete this image? This process cannot be undone.'
      )
      .then(confirmed => {
        if (confirmed) {
          if (this.getImage) {
            this.removeScenarioImage();
          } else {
            this.removeImage();
          }
        }
      });
  }

  removeScenarioImage() {
    this.administratorService.removeOrganizationImage(this.organizationId).subscribe((res: any) => {
      if (res.messageType) {
        this.toaster.error(res.message);
      } else {
        this.toaster.success(res.message);
        this.isShowChange = false;
        this.iserror = false;
        this.selectedFiles = null;

        // Reset the file upload component using ViewChild
        if (this.fileUploadComponent) {
          this.fileUploadComponent.reset();
        }

        if (this.myFileInput?.nativeElement) {
          this.myFileInput.nativeElement.value = '';
        }
        this.fileBase64 = null;
        this.getImage = null;
        this.isShowImage = false;
        this.isImageValid = true;

        // Clean up object URL if it exists
        if (this.currentBlobUrl) {
          URL.revokeObjectURL(this.currentBlobUrl);
          this.currentBlobUrl = null;
        }
        this.imageUrl = null;
      }
    });
  }

  onFileSelected(fileResult: any) {
    if (!fileResult.isValid) {
      this.isImageValid = false;
      return;
    }

    this.selectedFiles = fileResult.fileName;
    this.isShowChange = !!this.selectedFiles;
    this.isImageValid = true;

    if (fileResult.file) {
      if (this.currentBlobUrl) {
        URL.revokeObjectURL(this.currentBlobUrl);
      }

      const objectUrl = URL.createObjectURL(fileResult.file);
      this.currentBlobUrl = objectUrl;
      const safeUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);

      this.imageUrl = safeUrl;
      this.fileBase64 = fileResult.fileBase64;
      this.isShowImage = true;

      this.cd.detectChanges();
    }
  }

  onSave() {
    this.submitted = true;
    if (
      this.adminOrganizationForm.invalid ||
      this.adminOrganizationForm.controls['country'].value?.name == 'Country' ||
      this.adminOrganizationForm.controls['noOfLicence'].value == 0 ||
      this.adminOrganizationForm.controls['noOfLicence'].value === null ||
      this.isShowDateInvalid ||
      !this.isImageValid
    ) {
      return;
    }

    const starDate =
      typeof this.adminOrganizationForm.controls['startDate'].value == 'object'
        ? this.helper.formatDate(this.adminOrganizationForm.controls['startDate'].value)
        : this.adminOrganizationForm.controls['startDate'].value;
    const expiryDate =
      typeof this.adminOrganizationForm.controls['expiryDate'].value == 'object'
        ? this.helper.formatDate(this.adminOrganizationForm.controls['expiryDate'].value)
        : this.adminOrganizationForm.controls['expiryDate'].value;
    const saveData: any = {
      organizationId: this.organizationId,
      name: this.adminOrganizationForm.controls['organizationName'].value.trimStart(),
      baseImgUrl: this.adminOrganizationForm.controls['baseUrl'].value,
      expDate: expiryDate,
      startDate: starDate,
      logoConsent: this.isLogoConsented,
      address: this.adminOrganizationForm.controls['address'].value,
      totalUsers: this.adminOrganizationForm.controls['noOfLicence'].value,
      countryId: this.adminOrganizationForm.controls['country'].value?.id,
      signupSource: this.sourceType,

      signupSourceComment:
        this.sourceType == SignupSourceType.Other ||
        this.sourceType == SignupSourceType.ConferenceTradeEvent
          ? this.adminOrganizationForm.controls['sourceComment'].value
          : '',
      licenseLevel: this.adminOrganizationForm.controls['licenseLevel'].value,
      licenseType: this.adminOrganizationForm.controls['licenseType'].value,
      countryName:
        this.adminOrganizationForm.controls['country'].value?.name == 'Country'
          ? ' '
          : this.adminOrganizationForm.controls['country'].value?.name,
      sessionManagement: this.adminOrganizationForm.controls['sessionTimeOut'].value,
    };

    // Only include image data if validation passes
    if (this.fileBase64 && this.isImageValid) {
      saveData.OrgnazationImage = this.fileBase64;
      saveData.OrgnazationFile = this.selectedFiles;
    }
    const selectedId = this.adminOrganizationForm.get('licenseLevel')?.value;
    const userCount = +this.adminOrganizationForm.get('noOfLicence')?.value;

    const selectedLevel = this.rangeList.find((item: any) => item.id === selectedId);

    if (selectedLevel && userCount >= selectedLevel.min && userCount <= selectedLevel.max) {
      this.saveNewAdminOrganizationEvent.emit(saveData);
      return;
    }
    // Mismatch found – find the correct level
    const matchingLevel = this.rangeList.find(
      (level: any) => userCount >= level.min && userCount <= level.max
    );

    const selectedName = selectedLevel?.levelName || 'Unknown';
    const matchingName = matchingLevel?.levelName || 'None';
    this.selectedName = this.spiltLicenseType(selectedName);
    this.matchingName = this.spiltLicenseType(matchingName);
    const htmlText = `<p>You selected <b>${this.selectedName}</b> but entered <b>${userCount}</b> users.
      <span>This fits <b>${this.matchingName}</b>.</span></p>
      <p>Keep the same?</p>`;
    this.swalService.confirm('License level mismatch', htmlText).then(confirmed => {
      if (confirmed) {
        (saveData['licenseLevel'] = this.adminOrganizationForm.controls['licenseLevel'].value),
          this.saveNewAdminOrganizationEvent.emit(saveData);
      } else {
        if (matchingLevel) {
          this.adminOrganizationForm.get('licenseLevel')?.setValue(matchingLevel.id);
          this.licenseUpdatedFlag = true;
        }
      }
    });
  }

  getListData() {
    this.administratorService.GetAdminOrganizatioList(allItemsPayload).subscribe((res: any) => {
      this.adminOrganizationListData = res.data;
    });
  }

  updateConsent(eve: any) {
    this.isLogoConsented = eve.target.checked;
  }

  selectedSource(eve: any) {
    if (!eve.id) return;
    this.sourceType = eve.id;
    if (
      this.sourceType == SignupSourceType.Other ||
      this.sourceType == SignupSourceType.ConferenceTradeEvent
    ) {
      this.showCommentBox = true;
      this.labelText =
        this.sourceType == SignupSourceType.Other ? 'Comment' : 'Please specify the event';
      this.adminOrganizationForm.controls['sourceComment'].clearValidators();
      this.adminOrganizationForm.controls['sourceComment'].reset();
      this.adminOrganizationForm.controls['sourceComment'].setValidators([
        Validators.required,
        Validators.pattern(/\S+/), // At least one non-space character
      ]);
    } else {
      this.showCommentBox = false;
      this.adminOrganizationForm.controls['sourceComment'].clearValidators();
      this.adminOrganizationForm.controls['sourceComment'].reset();
    }
    this.adminOrganizationForm.updateValueAndValidity();
  }

  clearSource() {
    this.sourceType = null;
    this.showCommentBox = false;
    this.adminOrganizationForm.controls['sourceComment'].clearValidators();
    this.adminOrganizationForm.controls['sourceComment'].reset();
    this.adminOrganizationForm.updateValueAndValidity();
  }
  onUserCountChange(): void {
    const license = this.rangeList.find((x: any) => x.id === this.selectedLicenseId);

    if (!license) {
      this.licenseMessage = 'Selected license not found.';
      return;
    }

    const suitablePlan = this.rangeList.find(
      (x: any) => this.userCount >= x.min && this.userCount <= x.max
    );

    if (this.userCount > license.max) {
      if (suitablePlan) {
        this.licenseMessage = `You added ${this.userCount} users, which exceeds the '${license.levelName}' license. The license will be upgraded automatically to '${suitablePlan.levelName}'.`;
      } else {
        this.licenseMessage = `You added ${this.userCount} users, which exceeds the '${license.levelName}' license. No suitable license plan found for this user count.`;
      }
    } else {
      this.licenseMessage = `You added ${this.userCount} users. Current license: '${license.levelName}'.`;
    }
  }

  onLicenseTypeChange(eve: any) {
    this.licenseTypeValue = +eve?.id || 0;

    this.isLicenseDurationDisabled = !this.licenseTypeValue || this.licenseTypeValue === 1;

    if (eve?.name === 'Trial') {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      this.startDateInput = tomorrow;

      const expiryDate = new Date(tomorrow);
      expiryDate.setDate(tomorrow.getDate() + 15);
      this.expiryDateInput = expiryDate;

      const trialOptionExists = this.durationList.some((item: any) => item.id === 'Trial15');
      if (!trialOptionExists) {
        this.durationList.unshift({ id: 'Trial15', name: '15 Days' });
        this.durationList = [...this.durationList];
      }

      setTimeout(() => {
        this.adminOrganizationForm.get('licenseDuration')?.setValue('Trial15');
      });
    } else {
      this.durationList = this.durationList.filter((item: any) => item.id !== 'Trial15');
      this.adminOrganizationForm.get('licenseDuration')?.setValue(null);
    }
  }

  spiltLicenseType(licenseType: string) {
    if (licenseType) {
      return licenseType.split(' ')[0];
    }
    return '';
  }

  onDurationChange(event: any) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (event?.id === 'SixMonths') {
      const sixMonthsLater = new Date(tomorrow);
      sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);
      this.startDateInput = tomorrow;
      this.expiryDateInput = sixMonthsLater;
    } else if (event?.id === 'OneYear') {
      const oneYearLater = new Date(tomorrow);
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      this.startDateInput = tomorrow;
      this.expiryDateInput = oneYearLater;
    }
  }
}
